import { Delete, Edit } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

const FaqListItem = ({ formData, onEdit, onDelete }) => {
  const stripHtml = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  return (
    <div
      style={{
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        padding: "16px 20px",
        backgroundColor: "#fff",
        boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "120px 1fr auto",
          gap: "12px",
          alignItems: "start",
        }}
      >
        {/* Question Row */}
        <span
          style={{
            fontWeight: 600,
            color: "#333",
            fontSize: "14px",
            paddingTop: "2px",
          }}
        >
          Question
        </span>
        <span
          style={{
            fontSize: "14px",
            color: "#555",
            lineHeight: "1.5",
          }}
        >
          {stripHtml(formData.question) || "—"}
        </span>
        {/* Action buttons aligned to first row */}
        <div style={{ display: "flex", gap: "4px" }}>
          <Tooltip title="Edit">
            <IconButton size="small" onClick={onEdit} color="primary">
              <Edit fontSize="small" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton size="small" onClick={onDelete} color="error">
              <Delete fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      </div>

      {/* Divider */}
      <div
        style={{
          borderTop: "1px solid #f0f0f0",
          margin: "12px 0",
        }}
      />

      {/* Answer Row */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "120px 1fr",
          gap: "12px",
          alignItems: "start",
        }}
      >
        <span
          style={{
            fontWeight: 600,
            color: "#333",
            fontSize: "14px",
            paddingTop: "2px",
          }}
        >
          Answer
        </span>
        <span
          style={{
            fontSize: "14px",
            color: "#555",
            lineHeight: "1.6",
          }}
          dangerouslySetInnerHTML={{ __html: formData.answer || "—" }}
        />
      </div>
    </div>
  );
};

export default FaqListItem;
